import {PlusOutlined, SearchOutlined} from '@ant-design/icons';
import {Button, Input, Select} from 'antd';
import React, {useRef, useMemo} from 'react';
import './style.css';
import filter_by from '../../../Assets/filter-by.svg';
import {generateYearOptions} from '../../../Util/commonUtility';
import {useNavigate} from 'react-router-dom';
import useLocalization from '../../../Localization';

const CommonAddNewListingWithFilter = ({
  setIsModalOpen,
  searchOnChange,
  onSearch,
  placeHolder,
  selectPlaceholder,
  registrtion_filter,
  List,
  handleChange,
  handleYearFilter,
  usedForMyEventsCart,
  selectedYearValue,
  categoryList,
  handleCategoryFilter,
  selectedCategoryValue,
  selectedStatusValue,
  addNew = true,
  usedForMyEvents = false,
  registerforNewEvent,
  search,
  year,
  pageName,
  status = true,
  location,
  selectedLocationValue,
  handleLocationFilter,
  filteredPosition,
  usedForPastEvents = true,
}) => {
  const {ApplicationString} = useLocalization();

  const selectRef = useRef(null);
  const yearOptions = generateYearOptions(ApplicationString, usedForPastEvents);
  const handleFocus = () => {
    selectRef.current && selectRef.current.blur();
  };
  const navigate = useNavigate();
  const clearFilter = usedForPastEvents
    ? {value: '', label: ApplicationString['eventListing.clearFilter']}
    : {value: '', label: ApplicationString['jobListing.clearFilter']};
  const listOptions = List?.length > 0 ? [clearFilter, ...List] : [];

  return (
    <React.Fragment>
      <div
        className={`listingWithFilterContainer ${
          filteredPosition ? 'filtered' : ''
        }`}>
        {addNew && (
          <div className='add-new-listing-button-container'>
            <Button
              type='primary'
              id='UserJobsComponent-filterButton-addJobs'
              prefixCls='add-new-listing-button'
              onClick={() => setIsModalOpen(true)}>
              <span className='add-new-listing-button-content'>
                {ApplicationString['userComponent.button.addListing']}{' '}
                {pageName}
              </span>
              <div>
                <PlusOutlined className='add-new-listing-icon' />
              </div>
            </Button>
          </div>
        )}
        <div
          className={`filter-search-container ${
            filteredPosition && 'filter-search'
          } ${usedForMyEventsCart && 'filter-search-container-myEventsCart'} ${
            usedForMyEvents && 'flex-spaceBetween-w100'
          }`}>
          <div className='event-filter-type-container'>
            <div className='add-new-listing-filter-with-label-container'>
              <div className='filter-by-label' id='filterByLasbel'>
                <img src={filter_by} alt='filter-by-svg' />
                <span>{ApplicationString['eventListing.filterBy']}</span>
              </div>
              {status && (
                <Select
                  id={`myProfile-selectEvent-${selectPlaceholder}`}
                  showSearch
                  prefixCls='event_type_select_chapter'
                  defaultValue={selectPlaceholder}
                  // style={{width: '120px'}}
                  onChange={handleChange}
                  onSelect={handleFocus}
                  value={selectedStatusValue || selectPlaceholder}
                  // optionFilterProp='children'
                  filterOption={(input, option) =>
                    (option?.label ?? '').includes(input)
                  }
                  placeholder={
                    ApplicationString['eventListing.selectDefaultStatus']
                  }
                  options={listOptions}
                  ref={selectRef}></Select>
              )}
              {usedForMyEvents && (
                <Select
                  id='myProfile-selectEvent-category'
                  showSearch
                  prefixCls='event_type_select_chapter'
                  defaultValue={'History'}
                  onSelect={handleFocus}
                  onChange={handleCategoryFilter}
                  className='used-for-myevents-select'
                  value={
                    selectedCategoryValue ||
                    ApplicationString['eventListing.history']
                  }
                  // optionFilterProp='children'
                  filterOption={(input, option) =>
                    (option?.label ?? '').includes(input)
                  }
                  placeholder={
                    ApplicationString['eventListing.selectDefaultCategory']
                  }
                  options={categoryList}
                  ref={selectRef}></Select>
              )}
              {year && (
                <Select
                  id='myProfile-selectEvent-year'
                  showSearch
                  prefixCls='event_type_select_year'
                  defaultValue={ApplicationString['eventListing.selectYear']}
                  onSelect={handleFocus}
                  onChange={handleYearFilter}
                  value={
                    selectedYearValue ||
                    (usedForPastEvents
                      ? ApplicationString['eventListing.selectYear']
                      : ApplicationString['jobListing.selectYear'])
                  }
                  placeholder={
                    usedForPastEvents
                      ? ApplicationString['eventListing.selectDefaultYear']
                      : ApplicationString['jobListing.selectDefaultYear']
                  }
                  options={yearOptions}
                  ref={selectRef}></Select>
              )}
              {location && (
                <Select
                  id='myProfile-selectEvent-year'
                  showSearch
                  prefixCls='event_type_select_year'
                  defaultValue={selectPlaceholder}
                  onSelect={handleFocus}
                  onChange={handleLocationFilter}
                  value={selectedLocationValue || selectPlaceholder}
                  placeholder={ApplicationString['eventListing.selectLocation']}
                  filterOption={(input, option) =>
                    (option?.label ?? '').includes(input)
                  }
                  options={categoryList}
                  ref={selectRef}></Select>
              )}
            </div>
            {registrtion_filter && (
              <div className='registration-filter'>{registrtion_filter}</div>
            )}
            {registerforNewEvent && (
              <Button
                onClick={() => {
                  navigate(`/`);
                }}
                className='reg-navigation-btn register-for-new-event'>
                {
                  ApplicationString[
                    'userMyEventsComponent.button.registerForNewEvents'
                  ]
                }
              </Button>
            )}
          </div>

          {search && (
            <div
              id='userProfile-Search-input'
              className={`add-new-listing-search-container ${
                usedForMyEvents && 'mn-w-400px'
              }`}>
              <Input
                prefixCls='add-new-listing-search-input'
                placeholder={`${placeHolder}`}
                suffix={<SearchOutlined onClick={onSearch} />}
                onChange={searchOnChange}
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommonAddNewListingWithFilter;
